import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=087466c4&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087466c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087466c4')) {
      api.createRecord('087466c4', component.options)
    } else {
      api.reload('087466c4', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=087466c4&scoped=true&", function () {
      api.rerender('087466c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/center/page/Article.vue"
export default component.exports